import EcoNavPage from 'eco-design/sections/eco-nav-page';
import { useLang } from '@/i18n';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.PageNavA');
    const itemsA = [
        {
            title: t('item1'),
            href: '#section-1',
        },
        {
            title: t('item2'),
            href: '#section-2',
        },
        {
            title: t('item3'),
            href: '#section-3',
        },
        {
            title: t('item4'),
            href: '#section-4',
        },
    ];
    return (
        <>
            <EcoNavPage items={itemsA} />
        </>
    );
}
